<page-header title="LICENSES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="getPagination('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getPagination('page')"
  [sort]="getPagination('sort')"
  [orderBy]="getPagination('order_by')"
  [columns]="columns"
  [filters]="filters"
  (onFilterChange)="handleFilterChange($event)"
  [showFilter]="true"
  [showReload]="true"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <button
        translationEditableDirective="CREATE_BUSINESS"
        *ngxPermissionsOnly="['CREATE_LICENSE']"
        class="button is-small is-info m-0"
        (click)="licenseTypeModalOpen = true"
      >
        {{ 'CREATE_BUSINESS' | translate }}
      </button>
    </div>
  </ng-template>

  <!-- <ng-template #addonRight>
    <form>
      <input
        [translationEditableModalDirective]="['SEARCH']"
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
      />
    </form>
  </ng-template> -->
  <ng-template let-row="row" #businessNameColumn>
    <span>{{ row.get('name') }}</span>
  </ng-template>

  <ng-template let-row="row" #code>
    <a [routerLink]="['/', 'licenses', row.get('id')]">{{ row.get('code') }}</a>
  </ng-template>

  <ng-template let-row="row" #checks>
    <span
      *ngIf="row.getIn(['checks', 'hasIssues']) || row.getIn(['checks', 'validationRequired'])"
      [tooltip]="getChecksTooltip(row)"
      content-type="html"
      tooltipClass="white-tooltip"
      theme="light"
      [options]="{ placement: 'left' }"
      [animationDuration]="0"
      [hideDelay]="0"
    >
      <i class="fas fa-exclamation-triangle has-text-warning-dark"></i>
    </span>
  </ng-template>

  <ng-template let-row="row" #propertyCode>
    <span
      style="width: 80px; display: block; text-align: center"
      *ngIf="!row.getIn(['propertyConnection', 'propertyId'])"
      >•</span
    >
    <a
      *ngIf="!!row.getIn(['propertyConnection', 'propertyId'])"
      [routerLink]="[
        '/properties/',
        row.getIn(['propertyConnection', 'propertyId'])
      ]"
      >{{ row.getIn(['propertyConnection', 'propertyCode']) }}</a
    >
  </ng-template>
</app-table>

<div class="modal is-active" *ngIf="licenseTypeModalOpen">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 380px; overflow: visible">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="SELECT_LICENSE_TYPE"
      >
        {{ 'SELECT_LICENSE_TYPE' | translate }}
      </span>
      <button
        class="delete"
        (click)="onClose($event)"
        aria-label="close"
      ></button>
    </div>

    <form class="modal-card-body p-5" style="overflow: visible">
      <div
        translationEditableDirective="LICENSE_TYPE_SELECTION_WARNING"
        class="notification is-danger is-light p-3"
        style="font-size: 15px"
      >
        {{ 'LICENSE_TYPE_SELECTION_WARNING' | translate }}
      </div>
      <div class="field">
        <label class="label" translationEditableDirective="LICENSE_TYPE">{{
          'LICENSE_TYPE' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="licenseTypes"
            [multiple]="false"
            [closeOnSelect]="true"
            bindLabel="name"
            (change)="selectedLicenseType = $event"
            bindValue="id"
            [ngModel]="selectedLicenseType?.id"
          >
          </ng-select>
        </div>
      </div>
    </form>
    <footer class="modal-card-foot">
      <button
        class="button is-success"
        (click)="onCreate($event)"
        translationEditableDirective="CREATE_BUSINESS"
        [disabled]="!selectedLicenseType"
        type="button"
      >
        {{ 'CREATE_BUSINESS' | translate }}
      </button>
      <button
        class="button"
        type="button"
        (click)="onClose($event)"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </button>
    </footer>
  </div>
</div>
